<template>
    <button @click="openIframeChat()">   
        <div v-if="showChatPopup">
            <img  :src="staticicon" alt="">
        </div>
        <img v-else  :src="btnicon" alt="">
    </button>
</template>
<script setup lang="ts">
import { useIframeStore } from '@/stores/chatAIStore';
import btnicon from '@/assets/tgpt/gif/Taia_v3_AuraCustom_full-2.gif'
import staticicon from '@/assets/tgpt/images/taia-icon.svg'
import { storeToRefs } from 'pinia';

const iframeStore = useIframeStore();
const { minimiseValue } = storeToRefs(iframeStore);

const showChatPopup = computed(() => iframeStore.showChatPopup);
    

const openIframeChat = () => {
    iframeStore.openIframe()
    iframeStore.updateInputSearchQuery()
    if(showChatPopup.value && minimiseValue.value) {
        iframeStore.handleMiniseAndMaxiseEvent(false)
    }
}
</script>